import { inject, provideAppInitializer } from '@angular/core';

export * from './security';
export * from './services';
export * from './messages';
export * from './toast';
export * from './models';
export * from './helpers';
export * from './data';

import { ApplicationSecurityServices } from './security';
import { ApplicationServices } from './services';
import { ToastService } from './toast';

export const CoreServices = [
    ...ApplicationSecurityServices,
    ...ApplicationServices,
    ToastService,
    provideAppInitializer(() => {
      const initializerFn = ((toastService: ToastService) => () => toastService.startListening())(inject(ToastService));
      return initializerFn();
    })
];